import { MapTo } from '@adobe/aem-react-editable-components';
import AdUnit, { AdUnitEditConfig } from './AdUnit';

export default MapTo('cob-corp-acquisition/components/creditonebank/ad-unit')(AdUnit, AdUnitEditConfig);